angular.module('iqxCore')
  .controller('WebReferenceCtrl', function ($scope, $location, $routeParams, $q, FormSvc, ApplicationSvc, $sce) {
    FormSvc.setOptions($scope, { notLoggedIn: true, autoEdit: true }) // stop the "please cancel or save your edits, message!"

    $scope.refCode = $routeParams.refid
    $scope.showForm = false
    $scope.isSubmitted = false
    $scope.postCompletedForm = false
    $scope.saveAndSubmit = true

    $scope.setSaveOrSubmit = function (v) {
      $scope.saveAndSubmit = v
      delete $scope.theRecord.PositionNotes
      delete $scope.theRecord.StartDate
      delete $scope.theRecord.EndDate
    }

    $scope.withdraw = function () {
      $scope.saveAndSubmit = false
      $scope.theRecord.Withdrawn = 1
      delete $scope.theRecord.PositionNotes
      delete $scope.theRecord.StartDate
      delete $scope.theRecord.EndDate
    }

    $scope.fetchDepartmentID = function () { // Returns the department based on the URLRefCode
      if (!$scope.refCode) { return $q.reject($scope.formError = 'Missing URLReferenceCode') }
      return $scope.fetch({
        fetchAPI: 'callresult_/NetReference?pReferenceRequestCode=' + $scope.refCode,
        fetchTarget: 'preRef',
        notLoggedIn: true,
        autoEdit: true
      })
    }

    $scope.myUpdate = function () {  // Over-ride the default update() called by the Save & Submit button
      $scope.withdrawn = $scope.theRecord.Withdrawn
      FormSvc.setSubmitted($scope, true)
      $scope.postCompletedForm = $scope.saveAndSubmit
      $scope.theRecord.Completed = $scope.saveAndSubmit ? 1 : 0;
      return FormSvc.update($scope, $scope.saveAndSubmit, !$scope.saveAndSubmit)  // Do not do the fetch if submitted
        .then(function () {
          $scope.showForm = !$scope.saveAndSubmit
          $scope.isCompleted = $scope.saveAndSubmit
          if (!$scope.saveAndSubmit) {
            if ($scope.withdrawn === 1) {
              $scope.showForm = false
              FormSvc.alert('Withdrawn', "Thank you for your time, your reference request has been removed.", 'info')
            } else {
              FormSvc.alert('Saved for later', "The reference has been saved but has not been sent. \n\r\nPlease bookmark this page or click on the link provided in the email we sent you to return to this form to complete the reference later.", 'info')
            }
          } else {
            FormSvc.alert('Thank you for your time', 'Your reference has been received. You may now close the page.', 'success')
          }
        })
        .catch(function (err) {
          $scope.formError = err
        })
    }

    $scope.fetchDepartmentID() // Get the department ID so it can fetch the correct questions
      .then(function () {
        if (!$scope.preRef.DepartmentID) {
          return $q.reject($scope.formError = 'Sorry, The Reference Request you are looking for has already been completed or has expired.')
        }

        FormSvc.setOptions($scope, {
          fetchAPI: 'callresult_/NetReference?pReferenceRequestCode=' + $scope.refCode,
          saveAPI: 'call_/NetReferenceSet',
          notLoggedIn: true, // we don't need them logged in =D
          autoEdit: true, // Switch form straight to edit mode
          saveCleanFields: true, // All fields sent
          primaryKey: "ReferenceRequestID",
          savePrefix: 'p',
          dateFields: ['StartDate', 'EndDate'],
          questionnaire: {
            tagTarget: 'tags',
            tagLocation: 'R' + $scope.preRef.DepartmentID,
            id: $scope.preRef.ReferenceRequestID,
            postVar: 'qanswers',
            questionGroup: $scope.preRef.RefType + '00',
            alwaysShowQGroup0: true,
            groupListAdditional: [4]
          }
        })
        $scope.update = $scope.myUpdate // call out custom update procedure before calling the normal one.
        return $scope.fetch()
          .then(function () {
            // Itterate through each $scope.tags for any with displaygroup as 4 and set  readonly to true
            $scope.tags.forEach(function (tag) {
              if (tag.displaygroup === 4) {
                tag.readonly = true
                tag.required = false
              }
            })
            // Allow HTML in the PositionNotes and remove PositionNotes from "theRecord" as we're not saving this back to the database
            $scope.PositionNotes = $sce.trustAsHtml($scope.theRecord.PositionNotes)
            $scope.StartDate = $scope.theRecord.StartDate
            $scope.EndDate = $scope.theRecord.EndDate
            delete $scope.theRecord.PositionNotes
            delete $scope.theRecord.StartDate
            delete $scope.theRecord.EndDate
            document.title = "Reference for " + $scope.theRecord.personName
          })
      })
      .then(function () {
        $scope.showForm = true
      })
  })